import { useMutation, useQuery } from "@tanstack/react-query"

import { useAPIClient } from "../../shared/context/client"
import { useLocalesState } from "../../shared/context/locales"

const useQueryContactCategories = () => {
    const { client } = useAPIClient()
    const { language } = useLocalesState()

    return useQuery({
        queryKey: ["getContactCategories"],
        queryFn: () => client.getContactCategories(language),
        meta: { errorToast: true },
    })
}

const usePostContact = () => {
    const { client } = useAPIClient()

    return useMutation({ mutationFn: body => client.postContact(body) })
}

export { useQueryContactCategories, usePostContact }
